
























































































































































import { VNode } from 'vue';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import { Subscription } from 'rxjs';
import { SwExtendedVue } from '../sw-extended-vue';
import SwNav from './sw-nav.vue';
import SwNavGroup from './sw-nav-group.vue';
import { CSSStyleOptions } from '../common-types';
import { ProvidedNavParam } from './types';
import { utilService } from '../util-service';
import { tooltip, TooltipDirValues } from '../tooltip-dir';

const cssPrefix = 'sw-nav-item';

/**
 * Events:
 * @event select `()`
 * @event mouseenter `()`
 * @event mouseleave `()`
 */
@Component({
  directives: {
    tooltip,
  },
})
export default class SwNavItem extends SwExtendedVue {
  @Prop({ type: String, required: true })
  navId: string;

  @Prop({ type: Boolean, default: false })
  asGroupTitle: boolean;

  /** take effective only when asGroupTitle is true */
  @Prop({ type: Boolean, default: false })
  groupSelected: boolean;
  @Prop({ type: Boolean, default: false })
  groupExpanded: boolean;

  @Prop({ type: Number, default: 0 })
  offsetLevel: number;

  @Prop({ type: Boolean, default: false })
  showMenuInsteadOfTooltipOnHover: boolean;

  cssPrefix = cssPrefix;
  eventSubscription: Subscription | null = null;

  @Inject()
  readonly navParam: ProvidedNavParam;

  @Inject()
  private claimSelectNavItem: SwNav['claimSelectNavItem'];

  @Inject()
  private claimHighlightReferrer: SwNav['claimHighlightReferrer'];

  get isSelected() {
    if (this.asGroupTitle) { return this.groupSelected; }
    return this.navParam.selectedHierarchy.findIndex((e: any) => e === this.navId) >= 0;
  }

  get isActive() {
    return (this.asGroupTitle && (this.groupSelected || this.groupExpanded)) || this.isSelected;
  }

  get isCollapsed() {
    return this.navParam.collapsed;
  }

  get offsetLevelStyle() {
    const style: CSSStyleOptions = {};
    if (this.offsetLevel > 0) {
      let useLevel = this.offsetLevel;
      const iconSlot = utilService.getVueScopedSlot(this.$scopedSlots, 'icon');
      if (iconSlot.length <= 0) {
        useLevel -= 1;
      }
      useLevel = 0; // FIXME: temporarily disable offset of submenus
      if (!this.navParam.collapsed && useLevel > 0) {
        style.paddingLeft = `${16 + (8 * useLevel)}px`;
      }
      if (this.isCollapsed) {
        style.paddingRight = '15px';
      }
    }
    return style;
  }

  get titleTooltip(): TooltipDirValues {
    return {
      enabled: !this.showMenuInsteadOfTooltipOnHover
        && this.isCollapsed && ((this.asGroupTitle && !this.groupExpanded) || (!this.asGroupTitle && this.offsetLevel === 0)),
      placement: 'right',
      content: (h): VNode[] => {// tslint:disable-line
        return utilService.getVueScopedSlot(this.$scopedSlots);
      },
    };
  }

  private isShown(): boolean {
    if (!this.$el) { return false; }
    if (!(this.$el as HTMLElement).offsetParent) { return false; }
    if (!this.asGroupTitle) {
      /** traverse back until SwNav to see if any ancestors is not expanded */
      for (
        let parent = this.$parent;
        parent && parent.$options.name !== SwNav.name;
        parent = parent.$parent
      ) {
        if (parent.$options.name === SwNavGroup.name) {
          if (!(parent as SwNavGroup).isExpanded) {
            return false;
          }
        }
      }
    }
    return true;
  }

  @Watch('isSelected')
  private checkClaimHighlight() {
    if (!this.isSelected || this.asGroupTitle || !this.isShown() || this.isCollapsed) { return; }
    const rect = this.$el.getBoundingClientRect();
    this.claimHighlightReferrer(this.navId, {
      top: rect.top,
      left: rect.left,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.width,
      height: rect.height,
    });
  }

  private onClick() {
    this.$emit('select');
    if (!this.asGroupTitle) {
      this.claimSelectNavItem(this.navId);
    }
  }

  private onMouseEnter () {
    if (this.isCollapsed && this.showMenuInsteadOfTooltipOnHover) {
      this.$emit('mouseenter');
    }
  }

  private onMouseLeave () {
    if (this.isCollapsed && this.showMenuInsteadOfTooltipOnHover) {
      this.$emit('mouseleave');
    }
  }

  private created() {
    this.eventSubscription = this.navParam.eventbus.subscribe((event) => {
      if (event !== 'request-check-highlight-referrer') { return; }
      this.checkClaimHighlight();
    });
  }

  private mounted() {
    this.$nextTick(() => {
      this.checkClaimHighlight();
    });
  }

  private beforeDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
      this.eventSubscription = null;
    }
  }
}
